// @ts-nocheck
import Sheet from 'atoms/sheet/sheet';
import SheetBody from 'atoms/sheet/sheetBody/sheetBody';
import * as dynamicGridSagaActions from 'models/dynamicGrid/sagaActions';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import * as tableColumnSagaActions from 'models/tableColumns/sagaActions';
import * as tableColumnSelectors from 'models/tableColumns/selector';
import SideCar from 'molecules/sidecar/sidecar';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import CustomizeViewModal from 'organisms/CustomizeViewModal';
import ThetaMenu from 'organisms/thetaMenu/thetaMenu';
import UploadData from 'organisms/uploadData';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ThetaGridPaginated from 'templates/thetaGridPaginated';
import * as constants from './constants';
import ThetaDeleteModal from 'organisms/deleteModal/deleteModal';
import ExportGrid from 'organisms/exportGrid';
import { REQUESTS } from 'utils/services/thetaretail/requests';
import { isMasterDataItemsWrite } from 'models/user/selector';
import { isMasterDataItemsDelete } from '../../../models/user/selector';
import GridActionBar from 'atoms/GridActionBar';
import GridCsvUpload from 'organisms/uploadData/gridCsvUpload';
import { isNewUploadEnabled } from 'models/user/selector';
import Button from 'atoms/button/button';
import { AttributeDetails } from './attributeDetails';
import { Switch, Tooltip } from 'antd';
import { togglePlanogramAttributeState } from './sagaActions';
import { createFiltersFromQueries } from 'models/dynamicGrid/query';
import { fetchBookmarksList } from 'models/bookmarks/sagaActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { Button as AntButton } from 'antd';

const PlanogramAttributesListing: React.FunctionComponent = (props) => {
	const [isUploadEnabled, toggleUpload] = React.useState<boolean>(false);

	const [isDeleteModal, toggleDeleteModal] = React.useState(false);
	const gridMeta = useSelector((state) => dynamicGridSelectors.getGridMetadata(state, constants.TABLE_ID));
	const [isAttributeDetails, toggleAttributeDetails] = React.useState(false);
	const tableId = constants.TABLE_ID.toString();
	const dispatch = useDispatch();
	const hasWriteAccess = useSelector(isMasterDataItemsWrite);
	const hasDeleteAccess = useSelector(isMasterDataItemsDelete);

	const isCustomizeViewModalEnabled = useSelector((state) => tableColumnSelectors.isCustomizeViewModalEnabled(state));

	React.useEffect(() => {
		dispatch(dynamicGridSagaActions.erpEnabled({ tableId: tableId }));
		dispatch(fetchBookmarksList({ tableId: tableId }));
	}, [tableId, dispatch]);

	const handleRefreshClick = React.useCallback(() => {
		dispatch(
			dynamicGridSagaActions.refreshGridData({
				tableId: constants.TABLE_ID,
			})
		);
	}, [tableId, dispatch]);

	const handleResetTableColumns = React.useCallback(async () => {
		dispatch(tableColumnSagaActions.resetTableColumnsAg(constants.TABLE_ID));
	}, [dispatch, tableId]);

	const customizeViewHandler = React.useCallback((isCustomizeViewModalEnabled: boolean) => {
		dispatch(tableColumnSagaActions.setCustomizeViewModal(isCustomizeViewModalEnabled));
	}, []);

	const handleMenuItemClick = React.useCallback(
		(option: string) => {
			switch (option) {
				case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
					return customizeViewHandler(true);
				case constants.MENU_ITEMS_VALUES.RESET_VIEW:
					return handleResetTableColumns();
				case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
					return toggleUpload(true);
				case constants.MENU_ITEMS_VALUES.DELETE:
					return deleteItems();
				default:
					return;
			}
		},
		[handleResetTableColumns]
	);

	const selectedItems = useSelector((state) => dynamicGridSelectors.getTableSelection(state, constants.TABLE_ID));
	const getDisabledStatus = React.useCallback(
		(option: any) => {
			switch (option.value) {
				case constants.MENU_ITEMS_VALUES.CUSTOMIZE_VIEW:
				case constants.MENU_ITEMS_VALUES.RESET_VIEW:
				case constants.MENU_ITEMS_VALUES.UPLOAD_DATA:
					return false;
				case constants.MENU_ITEMS_VALUES.DELETE:
					return !selectedItems?.selectedRowKeys?.length;
				default:
					return true;
			}
		},
		[selectedItems]
	);

	const hideCustomizeViewModal = React.useCallback(() => {
		customizeViewHandler(false);
	}, []);

	const uploadCloseClickHandler = React.useCallback(() => {
		toggleUpload(false);
	}, []);
	const searchQuery = useSelector((state) => dynamicGridSelectors.getGridFilters(state, constants.TABLE_ID));
	const tableSelection = useSelector((state) => dynamicGridSelectors.getTableSelection(state, constants.TABLE_ID));

	const handleBulkDeleteClick = () => {
		dispatch(
			togglePlanogramAttributeState({
				selection: tableSelection?.selectedRowKeys,
				isActive: false,
				isSelectAll: tableSelection?.isSelectAll,
				isBulkUpdate: true,
				selectAllSearch: JSON.stringify({
					filter: createFiltersFromQueries(searchQuery?.search, true),
				}),
			})
		);

		toggleDeleteModal(false);
	};

	const deleteItems = () => {
		toggleDeleteModal(true);
	};
	const isNewUpload = useSelector(isNewUploadEnabled);

	const gridConfig = {
		enableSelection: true,
		enableSorting: true,
		enableMultiSort: true,
		gridActions: hasDeleteAccess,
		customActions: {
			width: 100,
			enabled: true,
			component: ({ row }) => {
				return (
					<Stack gutter="medium" align="center">
						<StackItem>
							<Switch
								checked={row?.IsActive}
								size="small"
								onClick={() => {
									dispatch(
										togglePlanogramAttributeState({
											row,
											id: row?.PlanogramAttributeID,
											isActive: !row?.IsActive,
										})
									);
								}}
							/>
						</StackItem>
					</Stack>
				);
			},
		},
		selectionCallBack: () => {},
	};

	const templateConfig = {
		gridConfig,
		tableId,
		dataProviderOptions: {
			type: 'POST',
			...REQUESTS.POST.GET_GRID_DETAILS_V2,
			pathParams: { tableId },
			version: 2,
		},
		selectRowKey: 'PlanogramAttributeID',
	};

	return (
		<>
			<Stack isVertical>
				<StackItem>
					<GridActionBar>
						<div className="content-head">
							<Stack gutter="medium" align="right">
								<StackItem className="content-head-rt">
									<Stack gutter="medium" className="action-btns">
										<StackItem>
											<Button
												type="primary"
												name={'Create Planogram Attribute'}
												handleClick={() => toggleAttributeDetails(true)}
											>
												<i className="icon-add" /> Create New Attribute
											</Button>
										</StackItem>
										{isNewUpload && gridMeta?.UploadTableID && (
											<StackItem className="action-btn">
												<GridCsvUpload
													uploadTableId={gridMeta?.UploadTableID}
													parentTableId={tableId}
												/>
											</StackItem>
										)}
										<StackItem className="action-btn">
											<Tooltip title="Refresh">
												{' '}
												<AntButton
													className="menu-action--button"
													icon={
														<FontAwesomeIcon className="font-icon" icon={faArrowsRotate} />
													}
													onClick={handleRefreshClick}
												/>
											</Tooltip>
										</StackItem>
										<StackItem className="action-btn">
											<ExportGrid tableId={constants.TABLE_ID} />
										</StackItem>
										<StackItem className="action-btn">
											<Tooltip title="More Options">
												{' '}
												<ThetaMenu
													type="3Dots"
													options={
														hasWriteAccess
															? constants.MENU_ITEMS
															: [constants.MENU_ITEMS[0]]
													}
													handleItemClick={handleMenuItemClick}
													isDisabled={getDisabledStatus}
												/>
											</Tooltip>
										</StackItem>
									</Stack>
								</StackItem>
							</Stack>
						</div>
					</GridActionBar>
				</StackItem>
				<StackItem isStretch isGrow className="order-tbl">
					<SheetBody>
						<Stack isVertical>
							<StackItem isStretch></StackItem>
							<StackItem isStretch isGrow>
								<Sheet isPage>
									<Stack isVertical gutter="tiny">
										<StackItem align="right" isStretch></StackItem>
										<StackItem isGrow isStretch>
											<ThetaGridPaginated key={tableId} config={templateConfig} />
										</StackItem>
									</Stack>
								</Sheet>
							</StackItem>
						</Stack>
					</SheetBody>
				</StackItem>
			</Stack>

			{isCustomizeViewModalEnabled && (
				<CustomizeViewModal hideModal={hideCustomizeViewModal} tableId={constants.TABLE_ID} />
			)}
			{isUploadEnabled && (
				<SideCar isActive={isUploadEnabled} handleOnClose={uploadCloseClickHandler}>
					<UploadData tableId={tableId} />
				</SideCar>
			)}
			{isDeleteModal && (
				<ThetaDeleteModal
					hideModal={() => {
						toggleDeleteModal(false);
					}}
					modalTitle={'ITEMS'}
					title={` (${
						selectedItems?.isSelectAll ? 'All' : selectedItems?.selectedRowKeys?.length
					}) selected  item(s)`}
					handleDeleteClick={handleBulkDeleteClick}
					isLocked={true}
				/>
			)}
			{isAttributeDetails && <AttributeDetails onHide={() => toggleAttributeDetails(false)} />}
		</>
	);
};
export default PlanogramAttributesListing;
